<template>
    <div>

        <el-dialog :visible.sync="newDialog" center :close-on-click-modal="true" custom-class="dialog_normal2"
            :append-to-body="true" @close="chasPrivilegeDialog">
            <div class="detail_cont">
                <h3 style="margin-bottom: 20px!important;">Add companies</h3>
                <!-- <h4 class="font20 textdecoration cuspoint  flex_center_end font1290C9 margin-bottom10"> <span  class="font20" @click="showReportIndex=true">No matching data available</span></h4> -->
                <div class="flex_center_bettwen">
                    <div class="head_search flex_center " ref="input">
                        <!-- 选择国家 -->
                        <div class="search_left" :class="countryImg ? 'on' : ''">
                            <div class="country_flag">
                                <img :class="countryImg ? 'country_flag_img' : 'none'" :src="countryImg" />
                            </div>
                            <el-select v-model="countryCode" ref="select" clearable @clear="clearCountry"
                                placeholder="Select country" popper-class="sel_box sel_Contry" @change="selectCountry"
                                no-match-text="No data" no-data-text="No data">
                                <div class="search_sel_container">
                                    <el-tabs tab-position="left" v-model="tabActiveName">
                                        <el-tab-pane v-for="(tab, index) in tabCountryList" :key="index">
                                            <div slot="label" class="flex_center_between_box">
                                                <span class="left_txt">{{ tab.continent.enName }}</span>
                                                <span class="right_txt">{{
                                                    tab.continent.countryNumStr
                                                }}</span>
                                            </div>
                                            <div class="right">
                                                <el-option v-for="item in tab.countryList" :key="item.id"
                                                    :value="item.countryCode" :label="item.nameEn"
                                                    v-show="item.companyNum > 100">
                                                    <div class="right_item flex_box">
                                                        <div class="img flex_center">
                                                            <img :src="item.urlBanner" />
                                                        </div>

                                                        <div class="rBox">
                                                            <div class="coun_title">{{ item.nameEn }}</div>
                                                            <div class="coun_num">{{ item.companyNumStr }}</div>
                                                        </div>
                                                    </div>
                                                </el-option>
                                            </div>
                                        </el-tab-pane>
                                    </el-tabs>
                                </div>
                            </el-select>
                        </div>
                        <div class="search_btn flex_center">
                            <svg t="1725588301247" class="icon" viewBox="0 0 1024 1024" version="1.1"
                                xmlns="http://www.w3.org/2000/svg" p-id="6045" width="20" height="20">
                                <path
                                    d="M863.38 825.09L714.17 675.88c48.01-57.12 74.18-128.58 74.18-204.08 0-84.89-33.06-164.7-93.08-224.72C635.24 187.05 555.44 154 470.55 154c-84.89 0-164.7 33.06-224.72 93.08s-93.08 139.83-93.08 224.72 33.06 164.7 93.08 224.72 139.83 93.08 224.72 93.08c76.22 0 148.33-26.67 205.72-75.56l149.08 149.08a26.805 26.805 0 0 0 19.01 7.88c6.88 0 13.76-2.63 19.01-7.88a26.805 26.805 0 0 0 7.88-19.01c0-6.89-2.62-13.77-7.87-19.02zM206.53 471.8c0-145.58 118.44-264.02 264.02-264.02 145.58 0 264.02 118.44 264.02 264.02S616.13 735.82 470.55 735.82c-145.58 0-264.02-118.44-264.02-264.02z"
                                    fill="#8497AB" p-id="6046"></path>
                            </svg>
                            <!-- <img src="../../assets/img/head_search_ic.png" @click="searchCompanyByName()" /> -->
                        </div>
                        <!-- 搜索 -->
                        <div class="search_right flex_center">
                            <input type="text" :placeholder="$t('MyDatabase.Entercompanyname')" v-model="searchName"
                                class="search_input"
                                @keyup.enter="EnterSearch()" />
                        </div>
                    </div>
                    <span class="font20 textdecoration font1290C9 cuspoint" @click="FilterCompanyBgshow=true">Filter</span>
                </div>
                <div class="FilterCompanyBg" v-if="FilterCompanyBgshow">
                    <div class="flex_center_bettwen ">

                        <div class="cas_panel cas_loc">

                            <el-cascader ref="Industry" clearable  v-model="industryCheckList" :options="industryList"
                                filterable :props="optionsProps" :popper-append-to-body="true"
                                @change="menuCheck('Industry')" placeholder="Select Industry"
                                popper-class="cas_loc_boxindystry">
                                <template slot-scope="{ data }">
                                    <el-tooltip class="" effect="dark" :content="data.name" placement="top">
                                        <span class="casca_lab casca_labtwo">{{ data.name }}</span>
                                    </el-tooltip>
                                </template>
                            </el-cascader>
                        </div>
                        <div class="cas_panel cas_loc  ">
                            <el-select style="width: 100%;"  @change="menuCheck('Industry')" clearable v-model="companyTypeCheck" filterable
                                :popper-append-to-body="false" placeholder="Select Company Type">
                                <el-option v-for="(item, index) in companyTypeList" :key="index" :label="item.name"
                                    :value="item.value">
                                    <div class="flex-between-center">

                                        <span class="select-name">{{ item.name }}</span>
                                    </div>
                                </el-option>
                            </el-select>

                        </div>
                        <div class="cas_panel cas_loc ">
                            <el-select style="width: 100%;"  @change="menuCheck('Industry')" clearable v-model="companySizeCheck" filterable
                                :popper-append-to-body="false" placeholder="Select Company Size">
                                <el-option v-for="(item, index) in companySizeList" :key="index" :label="item.name"
                                    :value="item.value">
                                    <div class="flex-between-center">

                                        <span class="select-name">{{ item.name }}</span>
                                    </div>
                                </el-option>
                            </el-select>

                        </div>

                    </div>
                    <div class="flex_center_bettwen">


                        <div class="cas_panel  cas_loc margin-bottom0 ">
                            <el-select style="width: 100%;"  @change="menuCheck('Industry')" clearable v-model="companyStatusCheck" filterable
                                :popper-append-to-body="false" placeholder="Select Company Status">
                                <el-option v-for="(item, index) in companyStatusList" :key="index" :label="item.name"
                                    :value="item.value">
                                    <div class="flex-between-center">

                                        <span class="select-name">{{ item.name }}</span>
                                    </div>
                                </el-option>
                            </el-select>

                        </div>
                        <div class="cas_panel cas_loc  margin-bottom0 ">
                            <el-select style="width: 100%;"  @change="menuCheck('Industry')" clearable v-model="listedCompanyCheck" filterable
                                :popper-append-to-body="false" placeholder="Select listed companies">
                                <el-option v-for="(item, index) in listedCompanyList" :key="index" :label="item.name"
                                    :value="item.value">
                                    <div class="flex-between-center">

                                        <span class="select-name">{{ item.name }}</span>
                                    </div>
                                </el-option>
                            </el-select>

                        </div>
                        <div class="cas_panel cas_loc margin-bottom0 ">
                            <el-select style="width: 100%;"  @change="menuCheck('Industry')" clearable v-model="timePeriodCheck" filterable
                                :popper-append-to-body="false" placeholder="Select company years in business">
                                <el-option v-for="(item, index) in timePeriodList" :key="index" :label="item.name"
                                    :value="item.value">
                                    <div class="flex-between-center">

                                        <span class="select-name">{{ item.name }}</span>
                                    </div>
                                </el-option>
                            </el-select>

                        </div>
                    </div>
                </div>


                <div class="" style="position: relative; margin-top: 10px">
                    <div class="table_box draggable">
                        <el-table ref="treeTable" :key="refresh" :data="parentTable" height="650" empty-text="No Data"
                            border row-key="aaa_id" @selection-change="handleSelectionChange" style="width: 100%"
                            v-loading="parentTableloding">
                            <el-table-column type="selection" width="50"></el-table-column>

                            <el-table-column label="Co. Name" width="360" align="left" show-overflow-tooltip
                                :resizable="false" class-name="company company_link ">
                                <template slot-scope="scope">
                                    <div class="line_1" style="width: 340px">
                                        <img :src="scope.row.flag" />
                                        <div @click="setid(scope.row)" class="tbl_company line_1">
                                            {{ scope.row.company_name_en }}
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>


                            <el-table-column label="Country" prop="company_country" align="left" show-overflow-tooltip
                                :resizable="false">
                                <template slot-scope="scope">
                                    {{ getCountry(scope.row.company_country) }}
                                </template>
                            </el-table-column>
                            <el-table-column label="Industry" prop="isic_en" align="left" show-overflow-tooltip
                                :resizable="false" />

                            <el-table-column label="Co. Type" prop="company_class_en" align="left" show-overflow-tooltip
                                :resizable="false">
                            </el-table-column>
                            <el-table-column label="Co. Status" prop="status_en" align="left" show-overflow-tooltip
                                :resizable="false" />
                            <el-table-column label="Co. Size" prop="scale_en" align="left" show-overflow-tooltip
                                :resizable="false" />
                            <el-table-column label="Listed" prop="listing_status_en" align="left" show-overflow-tooltip
                                :resizable="false" />


                            <template slot="empty">
                                <div class="flex_center"
                                    style="justify-content: center !important;height: 100%;width: 100%;">
                                    <img style="height: 60%;" src="../../../../assets/images/noDate.png" alt="">
                                </div>

                            </template>
                        </el-table>
                        <div class="page_i_box">
                            <Page :totalFont="true" :total="page.total" :pageSize.sync="page.pageSize"
                                :currentPage="page.pageNo" @onPageChange="onPageChangeList"></Page>

                            <div class="search_rsult_txt line_2">{{ page.pageNo }}-{{ page.pageSize }}
                                of over {{
                                    page.total | FilterNum }}
                                results for " {{ searchName }}"</div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="dialog-footer flex_center margin-top20" style="justify-content: center !important;">
                <el-button class="btn_export btn_exporthui" @click="chasPrivilegeDialog">
                    <i class="iconfont icon-quxiao"></i>Cancel
                </el-button>
                <el-button :class="CompapareList.length == 0?'btn_export btn_exporthui':'btn_export'" :disabled="CompapareList.length == 0" @click="ConfirmAdd">
                    <i class="iconfont icon-queren"></i>Confirm
                </el-button>
            </div>
        </el-dialog>
        <ReLogin :reLoginPop="reLoginVis"></ReLogin>
    </div>
</template>
<script>
import { searchCompany, saveUserCompanyActions } from "@/api/searchApi.js";

import {
    getoptions,
} from "@/api/companyApi";
import { mixins1 } from "@/mixins/index";

import ReLogin from "@/components/ReLogin.vue";
import Page from '@/components/page/index.vue';

export default {
    mixins: [mixins1],
    // components: { Page },
    components: {
        ReLogin, Page
    },
    watch: {

    },
    computed: {
        newDialog: {
            get() {
                return this.addDialog;
            },
            set() { },
        },

    },
    props: {
        addDialog: {
            type: Boolean,
        },
        CompanyName: {
            type: String,
        },
        ComID: {
            type: Number,
        },



    },
    watch: {
        addDialog: {
            handler(newVal, oldVal) {
                if (newVal) {
                         this.page.pageNo=1
           this.industryCheck=''
            this.companyTypeCheck=''
            this.companySizeCheck=''
            this.companyStatusCheck=''
            this.companyStatusCheck=''
             this.timePeriodCheck=''
             this.industryCheckList=[]
             this.listedCompanyCheck=''
                    this.handleSelectionChange([])
                    if (this.$refs.treeTable) {
                        this.$refs.treeTable.clearSelection();

                    }
                    this.searchCompanyByName()
            this.getCondition()
                }

                // 这里可以进行一些逻辑处理或者触发其他操作
            },

            deep: true, // 深度监听，可以监听对象内部属性的变化
            immediate: true, // 立即执行一次handler函数，即使columns没有变化
        },
    },

    data() {
        return {
            reLoginVis: false,
            FilterCompanyBgshow:false,
            optionsProps: {
                label: "name", //名称展示
                value: "value", //值展示
                expandTrigger: "click", //次级菜单的展开方式
            },
            countryVal: "",




            page: {
                pageNo: 1,
                pageSize: 10,
                total: 0,
            },



            //国家分类
            tabCountryList: [],
            productloding: false,
            percentageerr: false,
            showReportIndex: false,
            cascInptIndustry: '',
            industryCheckList: [],
            countryCode1: "",
            countryCode: "",
            countryName: "", //选中国家
            countryImg: "", //选中国家的国旗
            tabActiveName: "", //选择的区域
            isNotice: true, //通知高亮
            searchName: "",
            parentTable: [],
            expands: [],
            branchflag: "",
            refresh: 0,
            CompapareList: [],
            parentTableloding: false,

            industryCheck: '',
            companyTypeCheck: '',
            companySizeCheck: '',
            companyStatusCheck: '',
            listedCompanyCheck: '',
            timePeriodCheck: '',
            timePeriodList: [],
            listedCompanyList: [],
            companyStatusList: [],
            companySizeList: [],
            companyTypeList: [],
            industryPreList: [],
            industryList: [],



        };
    },


    created() {
        this.getAllCountry()
    },
    methods: {
        EnterSearch(){
            this.page.pageNo=1
             this.industryCheck=''
            this.companyTypeCheck=''
            this.companySizeCheck=''
            this.companyStatusCheck=''
            this.companyStatusCheck=''
             this.timePeriodCheck=''
             this.industryCheckList=[]
             this.listedCompanyCheck=''
                if (this.$refs.treeTable) {
                        this.$refs.treeTable.clearSelection();

                    }
       this.CompapareList=[]
    
            this.searchCompanyByName()
            this.getConditions()
        },
        menuCheck(value) {
            this.page.pageNo=1
                if (this.$refs.treeTable) {
                        this.$refs.treeTable.clearSelection();

                    }
             this.CompapareList=[]
            this.searchCompanyByName()
            this.getConditions()
        },
        // 获取过略
        //获取左边菜单
        async getConditions() {




            const params = {
                company_name: this.searchName,
                company_country: this.countryCode,
                industry_en: this.industryCheckList[1],
                company_class_code: this.companyTypeCheck,
                scale_code: this.companySizeCheck,
                reg_status: this.companyStatusCheck,
                listing_status_code: this.listedCompanyCheck,
                years: this.timePeriodCheck,
            };
            await getoptions(params).then((res) => {
                if (res && res.code) {
                    this.countryList = res.data.geographicalLocation;
                    this.industryList = res.data.industry;
                    this.industryPreList = res.data.industry;

                    this.companyTypeList = res.data.companyTypeList;

                    // this.companyTypeList=
                    this.companySizeList = res.data.companySizeList;
                    this.companyStatusList = res.data.regStatus;
                    this.listedCompanyList = res.data.listingStatusList;
                    this.timePeriodList = res.data.yearsOfEstablishment;

                }
            });
        },
        ConfirmAdd() {
            let aaaidList = []
            this.CompapareList.map(item => {
                aaaidList.push(item.aaa_id)
            })
            saveUserCompanyActions(aaaidList).then(res => {
                if (res.code == 200) {
                    this.$emit('closeAdd', false)
                    this.$parent.getgetUserActionLogPage()
                    this.$message({
                        message: res.msg,
                        center: true,
                        type: 'success',
                    });

                } else {
                    this.$message({
                        message: res.msg,
                        center: true,
                        type: 'error',
                    });
                }
            })
        },
        closeDialog3(value) {
            this.showReportIndex = value;
        },
        chasPrivilegeDialog() {
            this.$emit('closeAdd', false)
        },
        async getAllCountry() {
            let countryCode = (this.countryCode = this.$route.query.companyCountry
                ? this.$route.query.companyCountry
                : "");
            // localStorage.setItem('countryList',JSON.stringify(countryImgList))
            // 处理缓存问题
            if (JSON.parse(localStorage.getItem("countryList"))) {

                this.tabCountryList = JSON.parse(localStorage.getItem("countryList"));
                let list = this.tabCountryList;
                list.forEach((item, index) => {
                    item.countryList.forEach((it) => {
                        let countryImg = "";
                        if (it.urlBanner == null) {


                            countryImg = require("../../../../../static/imagev2/zanwutupian.png");
                        } else {

                            countryImg = it.urlBanner.split("./../../../static")[1];
                        }
                        // let flag = require('../../static' + countryImg);
                        let flag = "";
                        try {
                            flag = require("../../../../../static" + countryImg);
                        } catch (error) {
                            countryImg = "../../../../../static/imagev2/zanwutupian.png";
                            // 提供一个默认值或者其他处理方式
                            flag = require("../../../../../static" + countryImg);
                        }
                        it.urlBanner = flag;
                        if (countryCode && it.countryCode == countryCode) {
                            this.countryName = it.nameEn;
                            this.countryImg = it.urlBanner;
                        }
                    });
                });
            }
        },
        onPageChangeList({ page, size }) {
            this.page.pageSize = size;
            this.page.pageNo = page
                if (this.$refs.treeTable) {
                        this.$refs.treeTable.clearSelection();

                    }
       this.CompapareList=[]
            this.searchCompanyByName();
        },
        currtentPageChange(pageSize) {
            this.page.pageSize = pageSize;
                        if (this.$refs.treeTable) {
                        this.$refs.treeTable.clearSelection();

                    }
       this.CompapareList=[]
            this.searchCompanyByName()
        },
        // 全选
        handleSelectionChange(selection) {
            this.CompapareList = selection


        },

        // 点击跳转
        setid(row) {
            sessionStorage.setItem("company", JSON.stringify(row));
            let newscountry = JSON.parse(localStorage.getItem("countryList"))[0].countryList
                ;
            let companyCountryEn = "";
            newscountry.map((item) => {
                if (item.countryCode == row.company_country) {
                    companyCountryEn = item.dowjonesCountrycode;
                }
            });
            let routeData = this.$router.resolve({
                path:
                    "/index/company/detals/" +
                    row.aaa_id +
                    "/background/snapshot?id3a=" +
                    row.aaa_id +
                    "&companyCountry=" +
                    row.company_country +
                    "&companyCountryEn=" +
                    companyCountryEn +
                    '&keword=' + this.$route.query.keword,
            });

            window.open(routeData.href, "_blank");

        },
        //分页


        //清除选择的国家
        clearCountry() {
            this.countryImg = "";
            this.countryCode = "";
            this.countryCode1 = "";
        },

        //下拉选择国家
        selectCountry(val) {
            let countryImg = this.getCountryImgUrl(val);
            let flag = require("../../../../../static" + countryImg);
            this.countryImg = flag;
            this.countryCode = val;

            let newscountry = this.tabCountryList[0].countryList;
            newscountry.map((item) => {
                if (item.countryCode == val) {
                    this.countryCode1 = item.dowjonesCountrycode;
                }
            });
        },
        // 选中国家
        //搜索公司
        async searchCompanyByName() {

            this.parentTableloding = true;
            let params = {
                company_name: this.searchName,
                company_country: this.countryCode,
                page: this.page.pageNo,
                pageSize: this.page.pageSize,

                industry_en: this.industryCheckList[1],
                company_class_code: this.companyTypeCheck,
                scale_code: this.companySizeCheck,
                reg_status: this.companyStatusCheck,
                listing_status_code: this.listedCompanyCheck,
                years: this.timePeriodCheck,
            };
            let res = await searchCompany(params);
            this.parentTable = [];

            if (res.code == 200) {
                this.page.total = res.data.total;
                let list = (this.parentTable = res.data.rows);
                //查找本地图片
                list = list.map((item, index) => {
                    let countryImg = this.getCountryImgUrl(item.company_country);
                    let flag = require("../../../../../static" + countryImg);
                    this.parentTable[index].flag = flag;
                    this.refresh++;
                });
                this.parentTableloding = false;
            } else {
                this.loading = false;
                // this.addPopIndex2=true
                this.parentTable = [];
                this.parentTableloding = false;
                if (res.code == "1002") {
                    this.$message.error(res.msg)
                    this.page.pageNo = 1
                    this.searchCompanyByName()

                }
            }
            // }
        },
        //获取国家

        //add compant弹框
        Add() {
            this.parentTable = []
            this.countryImg = "";
            this.countryVal = "";
            this.searchName = "";

        },
        // 确定提交
        async submitAdd() {


        },








    },
};
</script>
<style scoped lang="less">
.country_img {
    position: absolute;
    top: 0.2857142857142857rem;
    left: 0.2857142857142857rem;
    z-index: 8;
}

.country_img img {
    width: 3.2857142857142856rem;
    height: 2.2857142857142856rem;
}

.el-select,
.el-autocomplete {
    width: 100%;
}



.cop_add {
    // width: 18.857142857142858rem;
    // width: 25%;
    height: 2.857142857142857rem;
    cursor: pointer;
}


/* 搜索 */
.head_search {
    width: 85%;
    // width: 67.85714285714286rem;
    height: 3.857142857142857rem;
    background: #ffffff;
    border-radius: 10px;
    border: 0.07142857142857142rem solid #cccccc;
    color: #022955;
    // margin: auto;
    // margin-left: 4.428571428571429rem;
}

.search_right {
    flex: 1;
    position: relative;
}

.search_input {
    width: 100%;
    word-wrap: break-word;
    line-height: 2.142857142857143rem;
    outline: none;
    border: none;
    // padding: 0 1.4285714285714286rem;
    font-size: 1.14285714rem;
}

.search_btn {
    width: 2.857142857142857rem;
    height: 3.857142857142857rem;
    cursor: pointer;
}

.search_btn img {
    width: 1.7142857142857142rem;
}

/* 选择下拉 */
.search_left {
    width: 17.142857142857142rem;
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
}

.search_left::after {
    content: "";
    position: absolute;
    right: 0;
    top: 1.2142857142857142rem;
    width: 0.07142857142857142rem;
    height: 1.4285714285714286rem;
    background-color: #e7eaed;
}

.search_left /deep/ .el-input__inner {
    border: none;
    font-size: 1.1428571428571428rem;
}

/deep/ .el-input__inner {
    padding-right: 0rem !important;
}

.country_flag {
    display: flex;
    align-items: center;
}

.country_flag_img {
    width: 2.5714285714285716rem;
    height: 1.5714285714285714rem;
    margin: 1.0714285714285714rem 0.14285714285714285rem 1.0714285714285714rem 1.0714285714285714rem;
    box-shadow: 0rem 0.07142857142857142rem 0.14285714285714285rem 0rem rgba(0, 0, 0, 0.2);
}

.sel_value {
    width: 4.571428571428571rem;
    font-size: 1rem;
    word-break: break-all;
}

.search_left .el-select {
    position: absolute;
    top: 0;
    width: 17.428571428571427rem;
}

.search_left /deep/ .el-select .el-input__inner {
    background-color: transparent;
    height: 3.7142857142857144rem;
    /* opacity: 0; */
    font-size: 1.1428571428571428rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.search_left.on /deep/ .el-select .el-input__inner {
    padding-left: 4.285714285714286rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.head_pro_cas /deep/ .el-input__inner::placeholder,
.search_left /deep/ .el-select .el-input__inner::placeholder {
    color: #666666;
    /* 红色 */
}

.head_pro_cas /deep/ .el-icon-arrow-down:before,
.search_left /deep/ .el-select .el-icon-arrow-up:before {
    color: #8497ab !important;
    // font-weight: 600;
}

.sel_place {
    width: 100%;
    line-height: 3.7142857142857144rem;
    padding-left: 1.4285714285714286rem;
    display: inline-block;
    font-size: 1rem;
}

.el-select-dropdown__wrap {
    max-height: 26.785714285714285rem !important;
}

/* .el-cascader__dropdown{
z-index: 9999999 !important;
} */
.el-select-dropdown__list {
    padding: 0.7142857142857143rem 0 !important;
}

.search_sel_container {
    width: 85.71428571428571rem;
}

.search_sel_container /deep/ .el-tabs--left .el-tabs__nav-wrap.is-left {
    // width: 17.142857142857142rem;
}

.search_sel_container /deep/ .el-tabs--left .el-tabs__nav-wrap.is-left::after {
    width: 0.07142857142857142rem;
    background-color: #eee;
}

.head_swi_keyword {
    position: relative;
}

.head_swi_keyword .el-switch,
.head_login .el-switch {
    height: 2.4285714285714284rem;
    line-height: 2.4285714285714284rem;
}

.head_swi_keyword /deep/ .el-switch__core,
.head_login /deep/ .el-switch__core {
    width: 7rem !important;
    height: 2.4285714285714284rem;
    background: #006a9a;
    box-shadow: inset 0rem 0.07142857142857142rem 0.14285714285714285rem 0rem #054562;
    border-radius: 1.2142857142857142rem;
    border: none;
}

.head_swi_keyword /deep/ .el-switch__core {
    width: 7.142857142857143rem !important;
}

.head_swi_keyword /deep/ .el-switch.is-checked .el-switch__core {
    background: #ff7600;
    box-shadow: inset 0rem 0.07142857142857142rem 0.14285714285714285rem 0rem #aa4f00;
}

.head_swi_keyword /deep/ .el-switch__core:after,
.head_login /deep/ .el-switch__core:after {
    top: 0.21428571428571427rem;
    left: 0.21428571428571427rem;
    width: 2rem;
    height: 2rem;
    background: #ffffff;
}

.head_swi_keyword /deep/ .el-switch.is-checked .el-switch__core::after {
    left: 6.142857142857143rem;
}

.search_sel_container /deep/ .el-tabs__active-bar {
    display: none;
}

.search_sel_container .right {
    width: 68.5rem;
    display: flex;
    flex-wrap: wrap;
    flex: 1;
    max-height: 24.285714285714285rem;
    align-content: flex-start;
    margin-right: 0.07142857142857142rem;
    padding: 0 0.571428571428571rem;
    overflow: auto;
}

.search_sel_container /deep/ .el-tabs--left .el-tabs__item.is-left {
    height: 3rem;
    // line-height: 3rem;
    margin-bottom: 0.5714285714285714rem;
    padding: 0 0.7142857142857143rem !important;
    display: flex;
    align-items: center;
}

.search_sel_container /deep/ .el-tabs__item.is-left.is-active {
    background: #F5F5F5;
}

.el-select-dropdown__item:hover {
    background: #F5F5F5;
}

.search_sel_container /deep/ .el-tabs__item:hover {
    color: #1290c9;
    font-weight: normal;
}

.search_sel_container .left_txt {
    font-size: 1.1428571428571428rem;
    margin-right: 10px;
}

.search_sel_container .right .el-select-dropdown__item {
    width: 15.857142857142858rem;
    height: 4rem;
    padding: 0 0.7142857142857143rem;
    margin: 0.3542857142857143rem 0.35714285714285715rem;
    border: 0.07142857142857142rem solid #fff;
    background: #F5F5F5
}

.search_sel_container .right /deep/ .el-select-dropdown__item.selected,
.search_sel_container .right /deep/ .el-select-dropdown__item.hover {
    background: #F5F5F5;
    /* border-radius: 1rem; */
    border: 1px solid #1290c9;
}

.search_sel_container .right /deep/ .el-select-dropdown__item.selected {
    color: #022955;
    font-weight: normal;
}

.right_item {
    height: 100%;
    width: 100%;
}

.search_sel_container .right .img {
    width: 3.857142857142857rem;
    height: 100%;
    margin-right: 0.35714285714285715rem;
}

.search_sel_container .right .rBox {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.search_sel_container .right .rBox .coun_title {
    font-size: 1.1428571428571428rem;
    line-height: 1;
    margin-bottom: 0.2857142857142857rem;
    max-width: 10rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.table_box /deep/ .el-table__empty-block .el-table__empty-text {
    width: auto;
    /* justify-content: flex-start !important; */
}

.list-title {
    width: 25%;
}

.CompanyNameActive {
    font-size: 1.2857142857142858rem;
    color: #1290c9;
    text-decoration-line: underline;
}

.el-select /deep/ .el-input__suffix {
    right: 1rem !important;
}

.content {
    padding: 0rem;
    margin: 0rem !important;
}

.flex_center {
    justify-content: flex-start;
}

.item_active {
    background: #f2f5f9;
    height: 10rem !important;
    position: relative;
}

.Deletepostion {
    position: absolute;
    top: 0.7142857142857143rem;
    right: 0.7142857142857143rem;
}

.Deletepostionleft {
    position: absolute;
    top: 0rem;
    left: 0.7142857142857143rem;
    width: 14.285714285714286rem;
    height: 2.857142857142857rem;
    background: #A6B7C9;
    border-radius: 0rem 0rem 1.4285714285714286rem 0rem;
    font-size: 1.2857142857142858rem;
    color: #FFFFFF;
    line-height: 2.857142857142857rem;
    display: flex;
    align-items: center;

}

.FilterCompanyBg .cas_panel {
    width: 32%;
}

.FilterCompanyBg /deep/ .el-input__inner,
.FilterCompanyBg /deep/ .el-cascader .el-input .el-input__inner:focus {
    height: 3.571rem !important;
    border-radius: 10px;
}
.FilterCompanyBg{
padding: 20px;
background: #F5F5F5;
border-radius: 6px;
margin-top: 10px;
}
.FilterCompanyBg /deep/ .el-cascader .el-input__icon{
font-size: 1.2857142857142rem;
color: #1A2332;
}

</style>